import { ContentChild, Directive, Input } from '@angular/core';
import { AccordionContent } from './accordion-content.directive';
import { AccordionHeader } from './accordion-header.directive';
import { AccordionTitle } from './accordion-title.directive';
import { AccordionHeaderContentDirective } from './accordion-header-content.directive';

@Directive({
  selector: 'accordion-item'
})
export class AccordionItemDirective {
  @Input() title = '';
  @Input() disabled = false;
  @Input() disableClose = false;
  @ContentChild(AccordionContent) content: AccordionContent;
  @ContentChild(AccordionTitle) customTitle: AccordionTitle;
  @ContentChild(AccordionHeader) customHeader: AccordionHeader;
  @ContentChild(AccordionHeaderContentDirective) customHeaderContent: AccordionHeaderContentDirective;
}
